import apiClient from "../common/apiClient";

export default class MastersController {
  async GetMastersBank() {
    try {
      return await apiClient.get("/masters/bank");
    } catch (error) {
      return error;
    }
  }
  async GetLocation(data) {
    try {
      return await apiClient.post("/masters/location", data);
    } catch (error) {
      return error;
    }
  }
  async GetMastersFeeYear() {
    try {
      return await apiClient.get("/masters/feeYear");
    } catch (error) {
      return error;
    }
  }
  async GetMastersFeeFor() {
    try {
      return await apiClient.get("/masters/feeFor");
    } catch (error) {
      return error;
    }
  }
  async GetMastersSubFeeFor(id) {
    if (!id) return null;
    try {
      return await apiClient.get(`/masters/subfeeFor/${id}`);
    } catch (error) {
      return error;
    }
  }
  async GetDonationType() {
    try {
      return await apiClient.get("/masters/donationType");
    } catch (error) {
      return error;
    }
  }
  async GetDonorType() {
    try {
      return await apiClient.get("/masters/donorType");
    } catch (error) {
      return error;
    }
  }  
  async GetMenus() {
    try {
      return await apiClient.get("/masters/menus");//GetMasters(params, token)
    } catch (error) {
      return error;
    }
  }  
}
